module.exports = __webpack_public_path__ + "static/media/mascaraHidratacao.268d37d0.jpeg";